import { EFeatureFlag, ESpecialOfferInternalViewModel } from 'constants/enums';
import {
  OfferDesignTypes,
  OfferTypeCardConfig
} from 'views/OfferDesign/OfferDesign.types';

import { GradientDirection } from 'components/AcGradientInput/AcGraidentInput.types';
import { FilterOption } from 'components/FilterComponents/FilterPopover/types';

import bonusImg from './pages/SelectOfferType/assets/bonus.png';
import bundleImg from './pages/SelectOfferType/assets/bundle.png';
import progressImg from './pages/SelectOfferType/assets/progress.png';
import promotionImg from './pages/SelectOfferType/assets/promotion.png';
import rewardImg from './pages/SelectOfferType/assets/reward.png';
import rollingImg from './pages/SelectOfferType/assets/rolling.png';

// TO BE REMOVED WHEN NEW COMPONENT IS AVAILABLE
export const GRADIENT_INPUT_STYLE =
  '[&_.formContent-input-fieldTitle]:!mb-[8px] [&_.formContent-input-fieldTitle_h3]:!text-sm [&_.formContent-input-fieldTitle_h3]:!font-medium [&_.formContent-input-fieldTitle_h3]:!font-inter [&_.formContent-input-fieldTitle_h3]:!leading-5 [&_.MuiInputBase-root]:!h-10 [&_.MuiInputBase-root]:!text-sm [&_.MuiInputBase-root]:!py-0 [&_.MuiOutlinedInput-root]:!rounded-md [&_.MuiInputAdornment-root_div]:!h-6 [&_.MuiInputAdornment-root_div]:!w-6';

export const OFFER_TYPE_DISPLAY_NAMES: Record<string, string> = {
  [OfferDesignTypes.SpecialOffer]: 'Promotion',
  [OfferDesignTypes.Bundle]: 'Bundle',
  [OfferDesignTypes.PopUp]: 'Popup',
  [OfferDesignTypes.TriggeredPopup]: 'Triggered Popup',
  [OfferDesignTypes.RollingOffer]: 'Rolling Offer',
  [OfferDesignTypes.ProgressBar]: 'Progress Bar',
  [OfferDesignTypes.RewardCalendar]: 'Reward Calendar'
};

export const OFFER_TYPE_FILTER_OPTIONS: FilterOption[] = [
  { label: 'Promotion', value: OfferDesignTypes.SpecialOffer },
  { label: 'Bundle', value: OfferDesignTypes.Bundle },
  { label: 'Popup', value: OfferDesignTypes.PopUp },
  { label: 'Triggered Popup', value: OfferDesignTypes.TriggeredPopup },
  { label: 'Rolling Offer', value: OfferDesignTypes.RollingOffer },
  { label: 'Progress Bar', value: OfferDesignTypes.ProgressBar },
  { label: 'Reward Calendar', value: OfferDesignTypes.RewardCalendar }
];

export const BUTTON_TEXT = 'Create New Offer Design';

export const ROUTE_SELECT_TYPE = 'select-type';

export const FILTER_PARAM_EXTERNAL_ID = 'externalId';
export const FILTER_PARAM_NAME = 'name';
export const FILTER_PARAM_TYPE = 'type';
export const FILTER_TYPE_SEPARATOR = ',';

export const OFFER_TYPE_CARDS: OfferTypeCardConfig[] = [
  {
    key: 'promotions',
    title: 'Promotions',
    description: 'Scheduled promotions featuring one or more products.',
    image: promotionImg,
    offerDesignType: OfferDesignTypes.SpecialOffer
  },
  {
    key: 'bundle',
    title: 'Bundle',
    description: 'Bundles of products sold as a discount or with bonus items.',
    image: bundleImg,
    offerDesignType: OfferDesignTypes.Bundle
  },
  {
    key: 'popup',
    title: 'Popup',
    description: 'Recurring rewards that encourage players to return.',
    image: bonusImg,
    offerDesignType: OfferDesignTypes.PopUp,
    flagTitle: 'Daily Bonus',
    flagTitleFlag: EFeatureFlag.DASHBOARD_DAILY_BONUS_SIDE_MENU
  },
  {
    key: 'triggered-popup',
    title: 'Triggered Popup',
    description: 'Popups triggered by purchases or store refreshes.',
    image: bonusImg,
    offerDesignType: OfferDesignTypes.TriggeredPopup,
    featureFlag: EFeatureFlag.DASHBOARD_DAILY_BONUS_SIDE_MENU
  },
  {
    key: 'rolling-offer',
    title: 'Rolling Offer',
    description: 'Unlock the next best offers after each transaction.',
    image: rollingImg,
    offerDesignType: OfferDesignTypes.RollingOffer
  },
  {
    key: 'progress-bar',
    title: 'Progress Bar',
    description: "Visualize the player's progress towards unlock a reward.",
    image: progressImg,
    offerDesignType: OfferDesignTypes.ProgressBar
  },
  {
    key: 'reward-calendar',
    title: 'Reward Calendar',
    description: 'Time-bound rewards that unlock on specific days or events.',
    image: rewardImg,
    offerDesignType: OfferDesignTypes.RewardCalendar
  }
];

export const OFFER_TYPE_LABELS: Record<OfferDesignTypes, string> = {
  [OfferDesignTypes.Bundle]: 'Bundle',
  [OfferDesignTypes.SpecialOffer]: 'Promotion',
  [OfferDesignTypes.PopUp]: 'Popup',
  [OfferDesignTypes.TriggeredPopup]: 'Triggered Popup',
  [OfferDesignTypes.RollingOffer]: 'Rolling Offer',
  [OfferDesignTypes.ProgressBar]: 'Progress Bar',
  [OfferDesignTypes.RewardCalendar]: 'Reward Calendar'
};

export const VALIDATION_TOAST_DESCRIPTIONS: Record<string, string> = {
  name: 'Please enter a name to continue',
  externalId: 'Please enter an external ID to continue',
  backgroundImage: 'Please upload a background image to continue',
  collectText: 'Please enter free offer text to continue',
  backgroundOpacity: 'Please set background opacity to continue',
  frameRadius: 'Please set frame radius to continue',
  accumulatedItemImageUrl: 'Please upload an accumulated image to continue',
  borderWidth: 'Please set border width to continue',
  badgeCoverImage: 'Please upload a badge cover image to continue',
  collectibleWidgetImage:
    'Please upload a collectible widget image to continue',
  lockedWidgetImage: 'Please upload a locked widget image to continue',
  collectIconImage: 'Please upload a collect icon image to continue',
  lockedIconImage: 'Please upload a locked icon image to continue'
};

export const SAVE_VALIDATION_MESSAGES = {
  nameUnique: {
    fieldKey: 'name',
    message: 'Name already exists',
    description: 'Please enter a unique name to continue'
  },
  externalIdUnique: {
    fieldKey: 'externalId',
    message: 'External ID already exists',
    description: 'Please enter a unique external ID to continue'
  },
  permission: {
    message: 'Permission denied',
    description: 'You do not have permission to edit this offer design'
  }
} as const;

export const DEFAULT_BACKGROUND_COLOR = '#FFFFFF';

export const PREVIEW_CONTAINER_WIDTH = 375;
export const PREVIEW_CONTAINER_HEIGHT = 667;

export const MOCK_PRICES = { priceDisplay: '$ 0.00', priceInUsdCents: 2 };

export const DEFAULT_BORDER_COLOR = { colorOne: '#ffffff' };
export const DEFAULT_BORDER_WIDTH = 0;

export const PROMOTION_DEFAULTS = {
  fontSize: 20,
  subFontSize: 16,
  fontWeight: 'normal',
  fontColor: { colorOne: '#ffffff' },
  collectText: 'Collect',
  templateType: 'Single'
} as const;

export const SUBTITLE_SUPPORTED_TEMPLATES: ESpecialOfferInternalViewModel[] = [
  ESpecialOfferInternalViewModel.JACKPOT_SLOTS,
  ESpecialOfferInternalViewModel.BIG_FISH_CASINO
];

export const POPUP_DEFAULTS = {
  backgroundColor: { colorOne: '#CACBD4' },
  fontSize: 20,
  fontWeight: 'normal',
  fontColor: { colorOne: '#FFFFFF' },
  subFontSize: 16,
  subFontWeight: 'normal',
  borderColor: { colorOne: '#FFFFFF' },
  borderWidth: 0
} as const;

export const TRIGGERED_POPUP_DEFAULTS = {
  backgroundColor: { colorOne: '#CACBD4' },
  fontSize: 20,
  fontWeight: 'normal',
  fontColor: { colorOne: '#FFFFFF' }
} as const;

export const PROGRESS_BAR_DEFAULTS = {
  backgroundOpacity: 80,
  frameRadius: 12,
  barRadius: 12,
  borderWidth: 3,
  barFillColor: {
    colorOne: '#FFD450',
    colorTwo: '#EDB923',
    gradientDirection: GradientDirection.TopToBottom
  },
  backgroundColor: {
    colorOne: '#DABA98',
    colorTwo: '#FDFCF9',
    gradientDirection: GradientDirection.LeftToRight
  },
  borderColor: {
    colorOne: '#DBBD9C',
    colorTwo: '#DBBD9C',
    gradientDirection: GradientDirection.LeftToRight
  },
  accumulatedItemBackgroundColor: {
    colorOne: '#F28CFE',
    colorTwo: '#9539FB',
    gradientDirection: GradientDirection.TopToBottom
  },
  accumulatedItemBackgroundImageUrl: '',
  textColor: '#FFFFFF'
} as const;

export const PROGRESS_BAR_PREVIEW_DEFAULTS = {
  collectedPoints: 100,
  activeMissionIndex: 0,
  missionsLength: 1
} as const;

export const ROLLING_OFFER_DEFAULTS = {
  backgroundColor: { colorOne: '#272727' },
  backgroundOpacity: 80,
  arrowColor: '#FFFFFF',
  borderColor: { colorOne: '#FFFFFF' },
  borderWidth: 0,
  subOfferBackgroundColor: { colorOne: '#FFFFFF' },
  collectText: 'FREE',
  lockImage: 'https://media.appcharge.com/defaults/lock_icon.png'
} as const;

export const REWARD_CALENDAR_DEFAULTS = {
  backgroundColor: '#E7CF88',
  dayFontColor: '#835500',
  lockedIconImage:
    'https://media.appcharge.com/defaults/reward-calendar/default_lock_icon.png',
  collectIconImage:
    'https://media.appcharge.com/defaults/reward-calendar/default_collected_icon.png'
} as const;

export const MOCK_PROGRESS_BAR_PRODUCTS = {
  barSize: 200,
  products: [
    {
      quantity: 100000,
      quantityDisplay: '100k',
      images: {
        product: 'https://media.appcharge.com/defaults/progress_bar_gift.png'
      }
    }
  ]
};

export const MOCK_ROLLING_OFFERS_PRODUCTS = Array.from(
  { length: 6 },
  (_, index) => ({
    index: index + 1,
    prices: {
      priceInUsdCents: 0,
      priceDisplay: '$ 0.00'
    },
    products: [
      {
        images: {
          product: ''
        }
      }
    ]
  })
);
